import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.css'],
  standalone: false
})
export class ForbiddenComponent {
  constructor(private router: Router) {}

  goToCustomers() {
    this.router.navigate(['/user/customers']);
  }
}